const ReportsConstantsEN = {
  reportsTitle: 'Reports',
  generateReportTitle: 'Generate Report',
  generateReportSubtitle: 'Choose the type of the report and date range and submit',
  reportsStartDate: 'Start Date',
  reportsEndDate: 'End Date',
  topSellingMediaReport: 'Top Selling Media',
  top10CustomersReport: 'Top 10 Customers',
  auditLogReport: 'Audit Log',
  top10SearchesReport: 'Top 10 Searches',
  allSearchReport: 'All Search Report',
  reportDetailsTitle: 'Top selling media',
  topSellingRank: 'Rank',
  topSellingMediaTitle: 'Media title',
  topSellingNumOfPurchase: 'Num of purchase',
  auditDate: 'Date timestamp',
  eventType: 'Event type',
  performedBy: 'Performed by',
  itemAffected: 'Item affected',
  create: 'create',
  update: 'update',
  delete: 'delete',
  saymaSystem: 'Sayma system ',
  adminUserEntity: 'Admin users',
  approvedDomainEntity: 'Approved domains',
  cmsEntity: 'Cms',
  mediaEntity: 'Media',
  systemSettingsEntity: 'System settings',
  userShoppingCart: 'Shopping cart',
  userOrderEntity: 'User orders',
  userInvoiceEntity: 'User Slips',
  termsAndConditions: 'Terms and conditions',
  cookiesPolices: 'Cookies policies',
  privacyPolicy: 'Privacy policy',
  faqs: 'FAQs',
  blog: 'Blog',
  successStories: 'Success stories',
  news: 'News',
  aboutUs: 'About us',
  checkoutTermsAndConditions: 'Checkout terms and conditions',
  searchTerm: 'Search term ',
  searchCount: 'Event Count',
  rank: 'Rank',
  title: 'Title',
  total: 'Event Count',
  topCustomerUserName: 'Customer name',
  topCustomerHighestOrderAmount: 'Highest order value',
  topCustomerTitle: 'Top 10 Customers',
  errorPeriodDateMsg: 'Invalid date range. Please select valid start and end dates.',
  customerName: 'Customer name',
  highestOrderValue: 'Highest order value',
  mediaExclusivity: 'Media Exclusivity',
  mediaExclusivityReferenceId: 'Reference Id',
  mediaExclusivityRightTypes: 'Rights',
  mediaExclusivityExclusivityTypes: 'Exclusivity',
  mediaExclusivityLicensePeriods: 'License Period',
  mediaExclusivityExclusiveMedia: 'Exclusive',
  mediaExclusivityHoldbackMedia: 'Holdback',
  mediaExclusivityMediaTitle: 'Media Name',
};

export default ReportsConstantsEN;
